import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubscriptionActivatedComponent } from './subscription-activated.component';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { LocaleConverterModule, NullCheckModule, PrecisionModule } from '@app/_shared';
import { EarningsFormatterModule } from '@app/_shared/pipes/earnings-formatter/earnings-formatter.module';



@NgModule({
  declarations: [
    SubscriptionActivatedComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    NullCheckModule,
    PrecisionModule,
    EarningsFormatterModule
  ],
  exports: [
    SubscriptionActivatedComponent
  ]
})
export class SubscriptionActivatedModule { }
